import { addToRecord, objectWithoutKeys } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { ThreadDwellTimeEndAction, ThreadDwellTimeStartAction } from '../../domains/threadDwellTime/actions.types';

import type { ThreadDwellTimes } from './types';

export type ThreadDwellTimeActions = ThreadDwellTimeStartAction | ThreadDwellTimeEndAction;

const initialState: ThreadDwellTimes = {};

const reducer: Reducer<ThreadDwellTimes, ThreadDwellTimeActions> = (state = initialState, action) => {
  switch (action.type) {
    case 'THREAD.DWELLTIME_START':
      return addToRecord(state, action.payload.id, action.payload);
    case 'THREAD.DWELLTIME_END':
      return objectWithoutKeys(state, [action.payload.id]);
    default:
      return state;
  }
};

export default reducer;
